var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.purchase.actions.customer.supplementary_agreement === "create"
        ? [
            !_vm.createSupplementaryAgreement
              ? _c(
                  "b-dropdown",
                  {
                    attrs: {
                      text: "Заключить дополнительное соглашение",
                      variant: "custom-green",
                    },
                  },
                  _vm._l(
                    _vm.$globalDictionaries.fl44SupplementaryAgreementTypes,
                    function (type) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: type.id,
                          staticClass: "fs-14",
                          on: {
                            click: function ($event) {
                              return _vm.createClicked(type.id)
                            },
                          },
                        },
                        [_vm._v(_vm._s(type.title))]
                      )
                    }
                  ),
                  1
                )
              : _c(_vm.createComponent, {
                  tag: "component",
                  attrs: { purchase: _vm.purchase },
                  on: {
                    cancel: function ($event) {
                      _vm.createSupplementaryAgreement = false
                    },
                    done: _vm.onSend,
                  },
                }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }